import LocaleStrings from "Languages";

export function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

/* send file file name it will return extension of that file */
export function getExtension(filename) {
  //return (extension = filename.split(".").pop());
  return filename.split(".").pop();
}

/* Convert any value to pixel as per type */
export const convertToPixel = (type = "cm", val) => {
  let pixel = 0;

  if (type === "inch") {
    // Inch
    pixel = val * 96;
  } else {
    // Cm
    pixel = val * 37.795275591;
  }
  return pixel;
};

/* Convert any value to (pixel * 2) as per type */
export const convertToPixelDouble = (type = "cm", val) => {
  let pixel = 0;

  if (type === "inch") {
    // Inch
    pixel = val * 96;
  } else {
    // Cm
    pixel = val * 37.795275591;
  }
  return pixel * 2;
};

/* Inch to pixel converter */
export const inchToPixel = (inchVal) => {
  let pixel = inchVal * 96;
  return pixel;
};

/* Centimeter to inch converter */
export const centToInch = (centVal) => {
  let inch = centVal / 2.54;
  return inch;
};

/* Centimeter to inch converter */
export const inchToCent = (inchVal) => {
  let cm = inchVal * 2.54;
  return cm;
};

/* Centimeter to pixel converter */
export const centToPixel = (centVal) => {
  let pixel = centVal * 37.795275591;
  return pixel;
};

/* Centimeter to pixel converter  
[Note :- As decided we will make this double in side ] 
*/
export const centToPixelDouble = (centVal) => {
  let pixel = centVal * 37.795275591;
  return pixel * 2;
};
// height: 487.68, width: 487.68

export const loadConfirmationButton = (confirm) => {
  // console.log(confirm);

  confirm.current.innerText = LocaleStrings.button_processing;
  confirm.current.style.opacity = "0.5";
  confirm.current.style.cursor = "default";
  confirm.current.disabled = true;

  confirm.current.nextSibling.style.opacity = "0.5";
  confirm.current.nextSibling.style.cursor = "default";
  confirm.current.nextSibling.disabled = true;
};
